import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {SaleDataService} from './SaleData.service';
import {SaleModel} from '../../../api/entity/sale.model';
import {SaleConverter} from '../../../api/entity/converter/sale.converter';


@Injectable({providedIn: 'root'})
export class SaleDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<SaleModel, SaleConverter> {
    constructor(dataService: SaleDataService, converter: SaleConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): SaleModel {
        return new SaleModel();
    }
}
